import { User } from "@/types/types";

export const isValidLengthSubscription = (
  conversionTimeLeftSeconds: User["conversionTimeLeftSeconds"],
  fileTimeSeconds: number
): boolean => {
  if (conversionTimeLeftSeconds === null) {
    return true;
  }

  return fileTimeSeconds <= conversionTimeLeftSeconds;
};
